var map = {
	"./loader": [
		"k9uZ"
	],
	"./loader.js": [
		"k9uZ"
	],
	"./privacy.en": [
		"3gle",
		7
	],
	"./privacy.en.js": [
		"3gle",
		7
	],
	"./privacy.zh": [
		"QHDz",
		6
	],
	"./privacy.zh.js": [
		"QHDz",
		6
	],
	"./safety.en": [
		"XFd4",
		5
	],
	"./safety.en.js": [
		"XFd4",
		5
	],
	"./safety.zh": [
		"1p9t",
		4
	],
	"./safety.zh.js": [
		"1p9t",
		4
	],
	"./support.en": [
		"Syc6",
		3
	],
	"./support.en.js": [
		"Syc6",
		3
	],
	"./support.zh": [
		"cK/M",
		2
	],
	"./support.zh.js": [
		"cK/M",
		2
	],
	"./terms.en": [
		"wBvw",
		1
	],
	"./terms.en.js": [
		"wBvw",
		1
	],
	"./terms.zh": [
		"lApr",
		0
	],
	"./terms.zh.js": [
		"lApr",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Wo4Q";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/i18n/policies lazy ^\.\/.*$
// module id = Wo4Q
// module chunks = 10 13 14 15 16